// extracted by mini-css-extract-plugin
export default {"context-menu":"ePQPv","focus-visible":"YHJbB","js-focus-visible":"sNKip"};